import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { useEffect, useRef, useState } from 'react';
import { badge } from './EventCalendar.Badge';
import { CalendarHeader } from './EventCalandar.Header';
import moment from 'moment';
import updateLocale from 'dayjs/plugin/updateLocale';
import { dateIndex } from 'utilities/utility.calendar';
import { useTranslation } from 'react-i18next';

dayjs.extend(updateLocale);

function getRandomNumber(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}

export const EventCalendar = ({ eventData, selectedEvent, setSelectedEvent }) => {
  
  const [isLoading, setIsLoading]               = useState(false);
  const [highlightedDays, setHighlightedDays]   = useState([]);

  const { i18n: { language } }          = useTranslation();

  const fetchHighlightedDays = (ED) => {
    const daysToHighlight = ED.map((ed) => new dayjs(ed.FromDate))
    setHighlightedDays(daysToHighlight);
    setSelectedEvent(daysToHighlight[0])
    setIsLoading(false);
  };


    // Replace "en" with the name of the locale you want to update.
  dayjs.updateLocale('en', {
      // Sunday = 0, Monday = 1.
    weekStart: 1,
  });

  useEffect(() => {
     if (eventData && eventData.length > 0) {
        fetchHighlightedDays(eventData);
      }
  }, [eventData]);


  return (
    <LocalizationProvider dateAdapter = {AdapterDayjs}>
      <DateCalendar
        value    = {selectedEvent}
        onChange = {(newValue) => {
          if(dateIndex(highlightedDays, newValue) >= 0) {
            setSelectedEvent(newValue)
          }
      }}
        loading               = {isLoading}
        renderLoading         = {() => <DayCalendarSkeleton />}
        disableHighlightToday = {true}
        slots                 = {{
          day           : badge,
          calendarHeader: CalendarHeader
        }}
        slotProps={{
          day: {
            highlightedDays,
            selectedEvent
          },
        }}
        dayOfWeekFormatter = {(date) => getDayNames(language, date)}
        sx                 = {{ background: '#fff', width: "100%", maxWidth: '300px', borderRadius: '16px', margin: 'unset', height: '297px' }}
      />
    </LocalizationProvider>
  );
}

const getDayNames = (locale = 'en', date) => {
      // Set the desired locale dynamically
    moment.locale(locale);
      // Generate a list of day names based on the dynamic locale
    return moment(date['$d']).format('dddd').substring(0, 3)
  };
  